import FolderApi from '@/api/folder'
import router from '@/router'

const setFoldersAction = ({ commit }, payload) => {
  commit('setFolders', payload)
}
const getFoldersAction = async ({ commit }, params) => {
  const folders = await FolderApi.getFolders(params)
  if (router.currentRoute.name === 'SharedWithMe') return
  commit('setFolders', folders)
  commit('setCurrentFolderDepth', null)
  commit('setBreadcrumbsMultipleLevelsArray', [])
}

const getTeamFoldersAction = async ({ commit }, params) => {
  const folders = await FolderApi.getTeamFolders(params)
  if (router.currentRoute.name !== 'Team') return
  commit('setFolders', folders)
}

// sub-folders
const getSubFoldersAction = async ({ commit }, params) => {
  const { parentFolderId } = params
  const { folders, breadcrumbs, depth } = await FolderApi.getSubFolders(parentFolderId, params)
  if (router.currentRoute.name === 'SharedWithMe') return
  commit('setFolders', folders)
  commit('setBreadcrumbsMultipleLevelsArray', breadcrumbs)
  commit('setCurrentFolderDepth', depth)
}

export default {
  setFoldersAction,
  getFoldersAction,
  getTeamFoldersAction,

  // sub-folders
  getSubFoldersAction,
}
